import { render, staticRenderFns } from "./LabSideRight.vue?vue&type=template&id=588b9ab7&"
import script from "./LabSideRight.vue?vue&type=script&lang=js&"
export * from "./LabSideRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports